import * as end from '../../../constants/api'
import { axiosInstance } from '../../../services/axios-instance'

const RegisterService = {
	registerUser: payload => {
		payload.device = navigator.platform
		return axiosInstance.post(end.register, payload).then(res => res.data)
	}
}

export default RegisterService
